import React from "react";

const Footer = () => {
  return (
    <footer className="w-full bg-white border-t border-gray-200 py-4">
      <div className="max-w-full px-6 text-center text-sm text-gray-500">
        © {new Date().getFullYear()} • Made by Mišel Vaukman
      </div>
    </footer>
  );
};

export default Footer;
